export const fetchLibratoUser = (state) => {
    let user = state?.admin?.librato?.user
    if (user === undefined) {
        user = 'admin@kiswe.com'
    }
    return user
}

export const fetchLibratoToken = (state) => {
    let token = state?.admin?.librato?.token
    if (token === undefined) { // safe guard
       console.log('using fallback token for librato')
       token = '1f48f1dc47d7a9673e8e8240c5c05915975cf4327f7891f7a591406e6742d966'
    }
    return token
}
